import { GrapevinePollEventsApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevinePollEventsApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new GrapevinePollEventsApi(configuration),
    [configuration]
  );
};
